// Components==============
import { evidenceCollectionType } from 'typings';
import { getDate } from 'utilities/getDate';
import { useRedux } from './useRedux';
// =========================

export function useEvidence() {
  const userId = useRedux((state) => state.authentication?.user?.id);

  const evidence = useRedux((state) => {
    const evidenceList: evidenceCollectionType[] = [];

    // training evidence
    const trainingSubscriptions = state.trainingSubscription?.entities.allIds.map(
      (id) => state.trainingSubscription?.entities.byId[id]
    );

    trainingSubscriptions
      ?.filter((t) => t?.attendances?.length)
      .forEach((t) => {
        if (!t) return;
        const trainingSubscription = t;

        trainingSubscription.attendances!?.forEach((a) => {
          a.evidence.forEach((e) => {
            if (e.created_by !== userId) return;

            const evidenceEntity: evidenceCollectionType = {
              type: 'training',
              id: trainingSubscription.training_id,
              title:
                state.training?.entities.byId[trainingSubscription.training_id]
                  ?.title,
              lesson: a.lesson_id,
              evidence: e,
            };

            evidenceList.push(evidenceEntity);
          });
        });
      });

    // Project evidence
    const allProjects = state.project?.entities.allIds.map(
      (projectId) => state.project?.entities.byId[projectId]
    );

    const myProjects = allProjects?.filter(
      (project) => project?.created_by === userId || !!project?.in_group
    );

    myProjects?.forEach((project) => {
      project?.process?.forEach((p) => {
        const process = state.process?.entities.byId[p];

        if (!process?.evidence?.length) return;

        process.evidence.forEach((e) => {
          const evidenceEntity: evidenceCollectionType = {
            type: 'project',
            id: project?.id,
            title: project?.theme_id
              ? state.theme?.entities.byId[project?.theme_id]?.name
              : undefined,
            evidence: e,
          };

          evidenceList.push(evidenceEntity);
        });
      });
    });

    return (
      evidenceList
        // only show evidence with training or project
        ?.filter((e) => e.title)
        ?.sort(
          (a, b) =>
            getDate(b?.evidence?.updated_at) - getDate(a?.evidence?.updated_at)
        )
    );
  });

  return evidence;
}
